import { writable, get } from 'svelte/store'
import { storeScene } from './scene'
import { ThreeItemKeys } from '../constants/three'

export const preferredPrinter = writable<PrinterModel | null>(null)

export function setPreferredPrinter(model: PrinterModel) {
  const scene = get(storeScene)
  if (scene) scene.userData[ThreeItemKeys.PREFERRED_PRINTER] = model
  preferredPrinter.set(model)
}
